import React, { Fragment } from 'react';
import {
  useGetBackstageLocationDetailsQuery,
  useGetBackstageLocationReportQuery,
} from '../../redux/api/locationApi';
import { useNavigate, useParams } from 'react-router-dom';
import { skipToken } from '@reduxjs/toolkit/query';
import FormatDateTime from '../../components/dateTime/FormatDateTime';

const BackstageLocationDetails = () => {
  const navigate = useNavigate();
  const { locationId } = useParams();
  const { data: locationData } = useGetBackstageLocationDetailsQuery(
    locationId ?? skipToken
  );
  const { data: locationReport } = useGetBackstageLocationReportQuery(
    locationId ?? skipToken
  );

  const reportItems = locationReport?.items ?? [];
  const deliveries = locationReport?.deliveries ?? [];

  return locationData ? (
    <Fragment>
      <h4>Lieferziel: {locationData.name}</h4>

      <h5>gelieferte Gesamtmengen</h5>
      {reportItems.length > 0 ? (
        <table className='table table-striped mt-4 align-middle text-start'>
          <thead>
            <tr>
              <th>Artikel</th>
              <th>gelieferte Menge</th>
            </tr>
          </thead>
          <tbody>
            {reportItems.map((line, index) => (
              <tr key={index}>
                <td>{line.article__name}</td>
                <td>{line.delivered_quantity}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <div className='alert alert-info'>
          Keine Lieferungen für {locationData.name} gefunden.
        </div>
      )}

      <h5 className='mt-4'>Lieferungen</h5>
      {deliveries.length > 0 ? (
        <table className='table table-striped align-middle text-start'>
          <thead>
            <tr>
              <th>#</th>
              <th>Datum</th>
              <th>Typ</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {deliveries.map((d) => (
              <tr key={d.id}>
                <td>{d.counter}</td>
                <td><FormatDateTime dateTime={d.confirmed_at} /></td>
                <td>
                  <span className={`badge ${d.type === 'RET' ? 'bg-warning text-dark' : 'bg-success'}`}>
                    {d.type === 'RET' ? 'Retoure' : 'Lieferung'}
                  </span>
                </td>
                <td>
                  <button
                    className='btn btn-sm btn-outline-secondary'
                    onClick={() => navigate(`/crew-delivery/${d.id}`)}
                  >
                    Details
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <div className='alert alert-info'>Keine Lieferungen gefunden.</div>
      )}
    </Fragment>
  ) : (
    <p>Fehler beim Laden vom Lieferziel.</p>
  );
};

export default BackstageLocationDetails;
